import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-side-panel-dialog',
  templateUrl: './side-panel-dialog.component.html',
  styleUrl: './side-panel-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidePanelDialogComponent {}
